import { Container, Grid, TextField } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import React, { useEffect, useState } from "react";
import Form from "../../../components/Form";
import "./seo.css";

import { createNewSeo, updatePollSeo } from "../../../redux/actions/polls.action";
import { useDispatch } from "react-redux";

const PollForm = ({ openForm, setOpenForm, pollDetails, setPollDetails, setIsEdit }) => {
  const [activeError, setActiveError] = useState(false);
  const [seoDataState, setSeoDataState] = useState({
    title: "",
    description: "",
    og_title: "",
    og_description: "",
    keywords: [],
    poll_id: "",
  });
  const [keywordState, setKeywordState] = useState([]);
  const [seoId, setSeoId] = useState("");

  const pollSeoData = pollDetails?.seo;
  const pollId = pollDetails?.id;

  const dispatch = useDispatch();

  useEffect(() => {
    if (pollSeoData) {
      const keywords = pollSeoData?.keywords?.map(e => e.keyword);
      setSeoDataState({
        title: pollSeoData?.title,
        description: pollSeoData?.description,
        og_title: pollSeoData?.og_title,
        og_description: pollSeoData?.og_description,
        keywords: keywords,
        poll_id: pollId,
      });
      setKeywordState(keywords);
      setSeoId(pollSeoData.id);
    } else {
      setSeoDataState({ poll_id: pollId });
      setKeywordState([]);
    }

    if (!openForm) {
      setActiveError(false);
    }
  }, [openForm]);

  //  Form validator...
  const formValidate = (seoData) => {
    if (
      !seoData.title ||
      seoData.title === "" ||
      !seoData.description ||
      seoData.description === "" ||
      !seoData.og_title ||
      seoData.og_title === "" ||
      !seoData.og_description ||
      seoData.og_description === "" ||
      !seoData.keywords ||
      seoData.keywords?.length === 0
    ) {
      setActiveError(true);
      return true;
    } else {
      return false;
    }
  };

  // Onchange state...
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if(e.target.name!=="keywords")
      setSeoDataState({ ...seoDataState, [name]: value });
  };

  // Submit the data...
  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await formValidate(seoDataState);
    if (res) {
      return;
    }
    // Call the API to upload data...
    if (!seoId || seoId==="") {
      dispatch(createNewSeo(seoDataState));
    } else {
      dispatch(updatePollSeo(seoId,seoDataState));
    }
    setOpenForm(false);
    setIsEdit(false);
    setSeoId("");
    setPollDetails({
      poll_name: "",
      question: "",
      duration_id: "1",
      start_date: "",
      options: [
        { option: "", image: null ,order:""},
        { option: "", image: null ,order:""},
      ],
      slug: ""
    });
  };

  //  Add keywords to the array...
  const addToKeywords = (e) => {
    if (e.key === "Enter" && e.code === "Enter") {
      if (e.target.value || e.target.value !== "") {
        setKeywordState([...keywordState, e.target.value]);
        let temp = [...keywordState];
        temp.push(e.target.value);
        setSeoDataState({ ...seoDataState, keywords: temp });
      }
      e.target.value = "";
    }
  };

  //  Remove keywords from the array...
  const removeKeyword = (keyword) => {
    const filterData = keywordState.filter((e) => e !== keyword);
    setSeoDataState({ ...seoDataState, keywords: filterData });
    setKeywordState(filterData);
  };

  return (
    <Form
      openForm={openForm}
      setOpenForm={setOpenForm}
      title={!pollSeoData ? "Create new SEO" : "Update SEO"}
      setDetails={setPollDetails}
      handleSubmit={handleSubmit}>
      <Container>
        <Grid container spacing={2} key="1" component="div">
          <Grid item xs={6}>
            <TextField
              margin="normal"
              required
              fullWidth
              autoFocus
              id="title"
              label="Title"
              name="title"
              onChange={handleInputChange}
              defaultValue={seoDataState.title}
              error={
                activeError &&
                (!seoDataState.title || seoDataState.title === "")
              }
              helperText={
                activeError &&
                (!seoDataState.title || seoDataState.title === "") &&
                "Title is required"
              }
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="description"
              label="Description"
              name="description"
              onChange={handleInputChange}
              defaultValue={seoDataState.description}
              error={
                activeError &&
                (!seoDataState.description || seoDataState.description === "")
              }
              helperText={
                activeError &&
                (!seoDataState.description ||
                  seoDataState.description === "") &&
                "Description is required"
              }
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} key="2" component="div">
          <Grid item xs={6}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="og_title"
              label="OG Title"
              name="og_title"
              onChange={handleInputChange}
              defaultValue={seoDataState.og_title}
              error={
                activeError &&
                (!seoDataState.og_title || seoDataState.og_title === "")
              }
              helperText={
                activeError &&
                (!seoDataState.og_title || seoDataState.og_title === "") &&
                "OG title is required"
              }
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="og_description"
              label="OG Description"
              name="og_description"
              onChange={handleInputChange}
              defaultValue={seoDataState.og_description}
              error={
                activeError &&
                (!seoDataState.og_description ||
                  seoDataState.og_description === "")
              }
              helperText={
                activeError &&
                (!seoDataState.og_description ||
                  seoDataState.og_description === "") &&
                "OG Desciption is required"
              }
            />
          </Grid>
        </Grid>
        {/* Keywords... */}
        <Grid container spacing={2} key="3" component="div">
          <Grid item xs={6} className="showInInputBox">
            <TextField
              margin="normal"
              required
              fullWidth
              label="Keywords"
              id="keywords"
              name="keywords"
              onChange={handleInputChange}
              onKeyUp={addToKeywords}
              error={
                activeError &&
                (!seoDataState.keywords || seoDataState.keywords?.length === 0)
              }
              helperText={
                activeError &&
                (!seoDataState.keywords ||
                  seoDataState.keywords?.length === 0) &&
                "Keyword is required"
              }
            />
            <div className="keywordBox">
              {keywordState.map((key, i) => {
                return (
                  <div key={i} className="keywords">
                    <p className="">{key}</p>
                    <span
                      className="deleteKeyword"
                      onClick={() => {
                        removeKeyword(key);
                      }}>
                      <ClearIcon />
                    </span>
                  </div>
                );
              })}
            </div>
          </Grid>
          {/* <Grid item xs={ 6 }
                        className="overflow-hidden "
                    >
                        <div className="keywordBox">
                            {keywordState.map((key,i)=>{
                                return (
                                <div key={i} className="keywords">
                                    <p className="">{key}</p>
                                    <span className="deleteKeyword" onClick={()=>{removeKeyword(key,i)}}><ClearIcon/></span>
                                </div>)
                            })}
                        </div>
                    </Grid> */}
        </Grid>
      </Container>
    </Form>
  );
};

export default PollForm;
